// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Iframe-module_iframe__JivJG {
    position: absolute;
    top: 0;
    left: 0;
    width: 1px;
    height: 1px;
    border-width: 0;
}

.Iframe-module_iframeFullScreen__S23z8 {
    width: 100%;
    height: 100%;
}
`, "",{"version":3,"sources":["webpack://./../../libs/core/src/components/ChallengeIframe/Iframe.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".iframe {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 1px;\n    height: 1px;\n    border-width: 0;\n}\n\n.iframeFullScreen {\n    width: 100%;\n    height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iframe": `Iframe-module_iframe__JivJG`,
	"iframeFullScreen": `Iframe-module_iframeFullScreen__S23z8`
};
export default ___CSS_LOADER_EXPORT___;
